import { DateTime } from "luxon";
import { ChildAge, parseChildAges } from "vacv-components";

export function parseDefaultDate(
  searchParams: URLSearchParams,
  urlParam: string,
  defaultDays: number
): string {
  const displayFormat = "dd/MM/yyyy";
  const param = searchParams.get(urlParam) ?? "";
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(param)) {
    return param;
  } else {
    // return today + days
    return DateTime.now().plus({ days: defaultDays }).toFormat(displayFormat);
  }
}

export function getChildAges(searchParams: URLSearchParams): ChildAge[] {
  // this parses search query parameters and returns and array of ChildAge objects
  const ages: number[] = parseChildAges(searchParams);
  return ages.map((age, index) => {
    return {
      child: index,
      age: age.toString(),
      value: age,
    } as ChildAge;
  });
}

export function getStringParam(
  searchParams: URLSearchParams,
  param1: string,
  param2?: string
) {
  if (typeof param2 === "string") {
    return searchParams.get(param1) ?? searchParams.get(param2) ?? "";
  }
  return searchParams.get(param1) ?? "";
}
